const product = {
    state: () => {
        return {
            lastVisitPathRouter:{}
        }
    },
    mutations: {
        handlePath(state,data){
            state.lastVisitPathRouter = data
        }
    },
    actions: {
        //设置路由路径
        setPath({ commit },data) {
            commit('handlePath', data)
        }
    },
    getters: {}
}
export default product